import React from 'react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

/**
 * Unified empty state for lists and pages.
 * Centered layout, white card, brand-tinted icon.
 */
const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action }) => {
  return (
    <div className="flex items-center justify-center py-16">
      <div
        className="text-center"
        style={{
          maxWidth: '400px',
          backgroundColor: 'var(--color-surface-card)',
          border: '1px solid var(--color-border-subtle)',
          borderRadius: '12px',
          boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
          padding: '40px 32px',
        }}
      >
        {icon && (
          <div
            className="mx-auto mb-4 flex items-center justify-center rounded-full"
            style={{
              width: '80px',
              height: '80px',
              backgroundColor: 'rgba(30, 58, 95, 0.06)',
              color: 'var(--color-brand-primary)',
            }}
          >
            {icon}
          </div>
        )}
        <h3
          className="font-semibold"
          style={{ fontSize: '16px', color: 'var(--color-text-primary)' }}
        >
          {title}
        </h3>
        {description && (
          <p
            className="mt-2 leading-relaxed"
            style={{ fontSize: '14px', color: 'var(--color-text-secondary)' }}
          >
            {description}
          </p>
        )}
        {action && (
          <div className="mt-5">
            {action}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
